import debounce from '../utils/rbata.debounce';

let debouncedSuggestSearchTracking = undefined;

const searchTracking = {

    trackSuggestSearch(term) {
        debouncedSuggestSearchTracking(term);
    },

    trackSearch(term, url) {
        dataLayer.push({
            'event':    'virtPath',
            'virtPath': `/search/?q=${encodeURI(term)}`
        });

        dataLayer.push({
            'event':               'ga4Event',
            'event_name':          'view_search_results',
            'view_search_results': {
                'value':        `${decodeURI(term)}`,
                'content_type': 'Suggest Search'
            },
            'eventCallback':       function () {
                if (url) {
                    location.href = url;
                }
            },
            'eventTimeout':        2000
        });
    },

    trackDebouncedSearch(term) {
        dataLayer.push({
            'event':    'virtPath',
            'virtPath': `/search/?q=${encodeURI(term)}`
        });

        dataLayer.push({
            'event':               'ga4Event',
            'event_name':          'view_search_results',
            'view_search_results': {
                'value':        `${decodeURI(term)}`,
                'content_type': 'Suggest Search'
            }
        });
    }

};

$(() => {
    debouncedSuggestSearchTracking = debounce(function (term) {
        searchTracking.trackDebouncedSearch(term);
    }, 3000);
});

export default searchTracking;
